<template>
  <div class="ma-3 ml-3 site_content">
    <div class="flex mb-deodorizer">
      <div class="info-setting">
        <div class="info-card">
          <h3>{{ device_name }}</h3>

          <div class="flex mt-3">
            <div class="plc_title"> 위치 </div>
            <div> {{ room }} </div>
          </div>

          <div class="flex mt-3">
            <div class="plc_title"> PLC </div>
            <div> {{ plc_name }} </div>
            <div class="plc_btn"> {{ btn_no }} 번</div>
          </div>

          <div class="weather-info" v-if="!nowweather.sensor || nowweather.sensor.pressure == null">
            <h3>기상청 정보</h3>
            
            <div class="flex ma-3">
              <v-icon class="mr-1" color="#005B96">mdi-weather-windy-variant</v-icon>
              <div class="weather-title"> 풍향 </div>
              <div id="deg_value" class="info_value"> {{ nowweather.wind.deg }}
                <span class="unit"> ° | &nbsp;</span>
              </div>
              <div class="info_value_direction" >
                {{ direction }}
              </div>
            </div>

            <div class="flex ma-3">
              <v-icon class="mr-1" color="#005B96">mdi-weather-windy</v-icon>
              <div class="weather-title"> 풍속 </div>
              <div id="deg_value" class="info_value"> {{ nowweather.wind.speed  }}
                <span class="unit"> m/s</span>
              </div>
            </div>

            <div class="flex ma-3">
              <v-icon class="mr-1" color="#005B96">mdi-speedometer</v-icon>
              <div class="weather-title"> 기압 </div>
              <div id="deg_value" class="info_value"> {{ nowweather.pressure  }}
                <span class="unit"> hPa</span>
              </div>
            </div>
          </div>

          <div class="weather-info" v-else>
            <h3>기상센서 정보</h3>
            
            <div class="flex ma-3">
              <v-icon class="mr-1" color="#005B96">mdi-weather-windy-variant</v-icon>
              <div class="weather-title"> 풍향 </div>
              <div id="deg_value" class="info_value"> {{ nowweather.sensor.wind.deg }}
                <span class="unit"> ° | &nbsp;</span>
              </div>
              <div class="info_value_direction" >
                {{ sensordirection }}
              </div>
            </div>

            <div class="flex ma-3">
              <v-icon class="mr-1" color="#005B96">mdi-weather-windy</v-icon>
              <div class="weather-title"> 풍속 </div>
              <div id="deg_value" class="info_value"> {{ nowweather.sensor.wind.speed }}
                <span class="unit"> m/s</span>
              </div>
            </div>

            <div class="flex ma-3">
              <v-icon class="mr-1" color="#005B96">mdi-speedometer</v-icon>
              <div class="weather-title"> 기압 </div>
              <div id="deg_value" class="info_value">{{ nowweather.sensor.pressure }}
                <span class="unit"> hPa</span>
              </div>
            </div>
          </div>

          <div class="weather-info">
            <h3>센서 정보</h3>
              <div v-for="(refer_sensor, i) in refer_sensor" :key="i">
                <div class="detail_info mt-2">
                  <div class="sensor_title mr-3">{{ refer_sensor.name }}</div>

                  <div class="sensor_detail">
                    <div>{{ refer_sensor.value }}
                      <span class="unit">{{ dataUnit(i,"") }}</span>
                    </div>

                    <div class="sensor_low" style="color:blue;">{{ refer_sensor.lowest }} {{ dataUnit(i,"") }} , &nbsp; 
                      <span style="color:red;">{{ refer_sensor.highest }} {{ dataUnit(i,"") }}</span>
                    </div>
                  </div>
                </div>
            </div>
          </div>

          <div class="set_date mt-2">설정일시 : {{chgdate}}</div>
        </div>
        
        <div class="flex vertical-center btn-container">
          <v-btn outlined rounded class="exit_btn mr-3" @click="exit()">이전</v-btn>
          <v-btn outlined rounded class="save_btn" :loading="loadingSave" v-if="this.$getters.userInfo.grade < 'UT06'" v-show=changed @click="save()">저장</v-btn>
        </div>
      </div>

      <div class="set-container">
        <v-form id="deodorizerSet">
          <!-- 시간 기준 제어 -->
          <div>
            <div class="flex">
              <div class="set_title">시간 기준 제어</div>

              <div class="switch-container">
                <label class="switch">
                  <input type="checkbox" v-model="timecontrol.on"  >
                  <span class="slider"></span>
                </label>
              </div>
            </div>

            <div class="deodorizer_set" v-show="timecontrol.on">
              <div v-for="(timecontrol,t) in timecontrol.set" :key="t">
                  <div class="setting">
                    <v-layout wrap>
                        <v-text-field dense outlined 
                          type="time"
                          id="time_start"
                          ref="time_start"
                          class="set_time shrink"
                          label="시작시간"
                          v-model="timecontrol.start"
                          value="12:00"/>

                          <v-text-field dense outlined 
                          type="time"
                          id="time_finish"
                          ref="time_finish"
                          class="set_time shrink"
                          label="종료시간"
                          v-model="timecontrol.finish"
                          value="23:59"/>

                          <v-text-field dense outlined 
                          type="number"
                          id="time_run"
                          ref="time_run"
                          class="run_time shrink mr-3"
                          label="작동"
                          v-model.number="timecontrol.run"
                          min=1
                          suffix="분"/>

                          <v-text-field dense outlined 
                          type="number"
                          id="time_stop"
                          ref="time_stop"
                          class="run_time shrink mr-3"
                          v-model.number="timecontrol.stop"
                          label="중지"
                          min=0
                          suffix="분"/>

                        <div class="trash" @click="removetime(t)">
                          <v-icon color="white">mdi-delete-empty</v-icon>
                        </div>
                    </v-layout>
                  </div>
              </div>

              <div class="reference mr-2" align="right"> ✽ 작동을 쉬지 않을 경우 중지에 0 을 입력하세요.</div>
              
              <v-row class="justify-end mb-1 mr-1 mt-1">
                <v-btn outlined rounded class="control_btn" @click="addtime()">
                  <v-icon color="#005B96">mdi-plus</v-icon>
                  추가</v-btn>
              </v-row>
            </div>
          </div>
        
          <!--센서 기준 제어-->
          <div class="mt-5">
            <div class="flex">
              <div class="set_title">센서 기준 제어</div>

              <div class="switch-container">
                <label class="switch">
                  <input type="checkbox" v-model="sensorcontrol.on"  >
                  <span class="slider"></span>
                </label>
              </div>
            </div>

            <div class="deodorizer_set" v-show="sensorcontrol.on">
              <div v-for="(sensorcontrol,s) in sensorcontrol.set" :key="s">
                  <div class="setting">
                    <v-layout wrap>
                      <v-select dense outlined class="sensor_select shrink mr-3"
                        id="sensor" 
                        ref="sensor" 
                        label="센서노드" 
                        v-model="sensorcontrol.sensor"
                        :items="sensorItems"
                        :menu-props="{ top: false, offsetY: true }"
                        no-data-text="자료(권한)이 없습니다."
                        item-text="name"
                        @change="changeSensor(s)"
                        return-object
                      />

                      <v-select dense outlined class="sensor_select shrink mr-3"
                        id="data_name" 
                        ref="data_name" 
                        label="센서종류" 
                        v-model="sensorcontrol.data_name"
                        :items="datanameItems[s]"
                        :menu-props="{ top: false, offsetY: true }"
                        no-data-text="자료(권한)이 없습니다."
                        item-text="name"
                        @focus="comboSensorData(s)"
                        return-object
                      />

                      <v-text-field dense outlined 
                        type="number"
                        id="data_run"
                        ref="data_run"
                        class="data_time shrink mr-3"
                        label="작동"
                        v-model.number="sensorcontrol.run"
                        min=0
                        max=2000
                        :suffix="dataUnit(s,'이상')"/>

                      <v-text-field dense outlined 
                        type="number"
                        id="data_stop"
                        ref="data_stop"
                        class="data_time shrink mr-3"
                        v-model.number="sensorcontrol.stop"
                        label="중지"
                        min=0
                        max=2000
                        :suffix="dataUnit(s,'이하')"/>

                      <div class="trash mr-2" @click="removesensor(s)">
                        <v-icon color="white">mdi-delete-empty</v-icon>
                      </div>
                    </v-layout>
                  </div>
              </div>
              
              <v-row class="justify-end mb-1 mr-1 mt-3">
                <v-btn outlined rounded class="control_btn" @click="addsensor()">
                  <v-icon color="#005B96">mdi-plus</v-icon>
                  추가
                </v-btn>
              </v-row>
            </div>
          </div>

          <div class="mt-5">
            <!-- 기상데이터 기준 On/off -->
              <div class="flex">
                <div class="set_title"  v-if="!nowweather.sensor || nowweather.sensor.pressure == null">기상 기준 제어</div>
                <div class="set_title" v-else> 기상센서 기준 제어</div>

                <div class="switch-container">
                  <label class="switch">
                    <input type="checkbox" v-model="weathercontrol.on"  >
                    <span class="slider"></span>
                  </label>
                </div>
              </div>

            <!-- 기상 센서 기준 On/off-->
            <div class="deodorizer_set" v-show="weathercontrol.on">
              <div v-for="(weathercontrol,w) in weathercontrol.set" :key="w"  >
                  <div class="setting">
                    <v-layout wrap>
                      <v-select dense outlined class="windset_time shrink"
                          id="weather_division"
                          ref="weather_division" 
                          v-model="weathercontrol.division"
                          :items="items_weather"
                          :menu-props="{top:false, offsetY:true}"
                          label="기상종류"
                          no-data-text="권한이 없습니다."
                          item-text="name"
                          return-object/>
                    
                        <v-text-field dense outlined 
                          v-show="weathercontrol.division.code  === 'pressure'"
                          type="number"
                          id="pressure_max"
                          ref="pressure_max"
                          v-model.number="weathercontrol.max"
                          class="weatherpres_set press shrink"
                          label="기압기준"
                          min=900
                          max=1030
                          :rules="rulespressure"
                          suffix="hPa 이하"/>
                    
                          <v-select 
                          v-show="weathercontrol.division.code  === 'deg'"
                          dense outlined class="weatherpres_set shrink"
                          id="wind_deg"
                          ref="wind_deg" 
                          v-model="weathercontrol.deg"
                          :items="items_wind_deg"
                          :menu-props="{top:false, offsetY:true}"
                          label="풍향"
                          item-text="name"
                          return-object
                          @change="setWindValue(w)"/>

                      <v-text-field dense outlined 
                        type="number"
                        id="weather_run"
                        ref="weather_run"
                        class="run_time shrink mr-3"
                        v-model.number="weathercontrol.run"
                        label="작동"
                        min=1
                        max=10
                        suffix="분"/>

                      <v-text-field dense outlined 
                        type="number"
                        id="weather_stop"
                        ref="weather_stop"
                        class="run_time shrink mr-2"
                        v-model.number="weathercontrol.stop"
                        label="중지"
                        min=0
                        max=10
                        suffix="분"/>
                      
                      <div class="trash" @click="removeweather(w)">
                        <v-icon color="white">mdi-delete-empty</v-icon>
                      </div>
                    </v-layout>
                  </div>
                </div>

                <v-row class="justify-end mb-1 mr-1  mt-3">
                  <v-btn outlined rounded class="control_btn" @click="addweather()">
                    <v-icon color="#005B96">mdi-plus</v-icon>
                    추가
                  </v-btn>
                </v-row>
            </div>

            <div class="mt-5">
              <div class="set_title">기후 제한 설정</div>

              <div class="deodorizer_set">
                <div class="flex set mb-deodorizer">
                  <div class="climate_title mr-5">작동 중지</div>
                  <div class="flex mb-check">
                    <v-checkbox
                      v-model="rainstop"
                      color="#005B96"
                      label="강우 시"
                      class="checkbox mr-5"
                    ></v-checkbox>

                    <v-checkbox
                      v-model="snowstop"
                      color="#005B96"
                      label="강설 시"
                      class="checkbox mr-5"
                    ></v-checkbox>

                    <div class="flex">
                      <v-checkbox
                      v-model="tempstop"
                      color="#005B96"
                      label="온도 설정시"
                      class="checkbox"
                    ></v-checkbox>

                    <div v-if="tempstop === true">
                      <v-text-field dense outlined 
                        type="number"
                        id="templessthan"
                        ref="templessthan"
                        class="temp_stop shrink ml-5"
                        label="중지기준온도"
                        v-model.number="templessthan"
                        suffix="°C 이하"/>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-form>
       
      </div>
    </div>
  </div>
</template>

<script>
import Apis from '@/api/apis';
import Common from "@/utils/custom/common.js";
import dateUtil from "@/utils/custom/dateProperty.js";

export default {
    name: "DeodorizerSet",

  async created(){
    Apis.pageCount({ //페이지뷰 카운터
      page_name: this.$route.name,
      url: this.$route.path,
      division: "cloud",
    },() => {  // 정상처리
    }).catch( (err) => {  // 개별 API 오류 처리 예제
      console.log("pageCount 호출 오류",err);
    });

    if (!this.isNull(this.$route.params)) {
      this.infoDeodorizerSetting(this.$route.params.id);
    } else {
      this.$router.go(-1);
    }

  },
  data(){
    return{
      id : "",

      // rulesdeg:[
      //   v => !! ( v < 360 ) || '0 ~ 359 의 숫자를 입력하세요.',
      //   v => !! ( v >= 0 ) || '0~ 359 의 숫자를 입력하세요.'
      // ],

      rulespressure:[
        v => !! ( v <= 1030 ) || '900~1030의 숫자를 입력하세요.',
        v => !! ( v >= 900 ) || '900~1030의 숫자를 입력하세요.'
      ],

      device_name:"",
      direction:"",
      sensordirection :"",
      farm : {},
      room : "",
      plc_name : "",
      btn_no : "",
      refer_sensor:[],
      nowweather : {pressure: "", weather: "", wind:{deg:"",speed:""}, sensor:{pressure:"", wind:{deg:"", speed:""}} },
      chgdate : "",
      sensorItems : [],
      datanameItems: [],
      items_weather:  [{code: "pressure", name: '기압'},{code: "deg", name: '풍향'}],
      items_wind_deg: [
                        {min: 292.5, max: 337.4,  name: '↘ 북서풍'},
                        {min: 337.5, max: 22.4,  name: '↓ 북풍'},
                        {min: 22.5, max: 67.4,  name: '↙ 북동풍'},
                        {min: 67.5, max: 112.4,  name: '← 동풍'},
                        {min: 112.5, max: 157.4,  name: '↖ 남동풍'},
                        {min: 157.5, max: 202.4,  name: '↑ 남풍'},
                        {min: 202.5, max: 247.4,  name: '↗ 남서풍'},
                        {min: 247.5, max: 292.4,  name: '→ 서풍'},
                      ],
    
      timecontrol : [],
      sensorcontrol : [],
      weathercontrol : [],

      rainstop: false , 
      snowstop: false , 
      tempstop : false,
      templessthan: "",

      mac:"",
      loading: false,
      loadingSave: false,
      changed: false,

    }
  },

  watch: {
    // 변경사항 없을시 저장 비활성
    timecontrol: {
      deep: true,
      handler() {this.changed = true;}
    },
    sensorcontrol: {
      deep: true,
      handler() {this.changed = true;}
    },
    weathercontrol: {
      deep: true,
      handler() {this.changed = true;}
    },
    rainstop: {
      deep: true,
      handler() {this.changed = true;}
    },
    snowstop: {
      deep: true,
      handler() {this.changed = true;}
    },
    tempstop: {
      deep: true,
      handler() {this.changed = true;}
    },
    templessthan: {
      deep: true,
      handler() {this.changed = true;}
    },
  },


  methods:{
    // windMask(val,w) {
    //   val = Common.getWindValue(val);
    //   if (val < 315) {
    //     this.weathercontrol.set[w].max = val + 44.9;

    //   } else {  
    //     this.weathercontrol.set[w].max = val - 360 + 44.9 ;   
    //   }
    //   return val;
    // },
    dataUnit(s,tail){
      return this.sensorcontrol.set[s] &&  Common.dataUnit(this.sensorcontrol.set[s].data_name.code) + tail || "";
    },
    // combomindirection(w){
    //   return Common.getDirection(this.weathercontrol.set[w].min);
    // },
    // combomaxdirection(w){
    //   return Common.getDirection(this.weathercontrol.set[w].max);
    // },
    setWindValue(w){
      // console.log("click",this.wind_deg);
      this.weathercontrol.set[w].min = this.weathercontrol.set[w].deg.min;
      this.weathercontrol.set[w].max = this.weathercontrol.set[w].deg.max;
    },
    checkData(){
      // console.log("time=",this.timecontrol);
      // console.log("sensor=",this.sensorcontrol);
      // console.log("weather=",this.weathercontrol);

      if (this.timecontrol.on) {
        if (!this.timecontrol.set.length) { 
          alert("설정된 시간 가동조건이 없습니다");
          return "설정된 시간 가동조건이 없습니다";
        }
          
        for (let i = 0; i < this.timecontrol.set.length; i++ ) {
          if (!this.timecontrol.set[i].start || this.timecontrol.set[i].start >= this.timecontrol.set[i].finish ){
            this.$refs.time_start[i].focus();
            return "시작~종료시간을 확인하세요.";
          }
          if (this.timecontrol.set[i].run < 0 ){
            this.$refs.time_run[i].focus();
            return "가동시간을 확인하세요.";
          }
          // if (this.timecontrol.set[i].stop < 1 ){
          //   this.$refs.time_stop[i].focus();
          //   return "중지시간을 확인하세요.";
          // }
        }
      }
      
      if (this.sensorcontrol.on) {
        if (!this.sensorcontrol.set.length) { 
          alert("설정된 센서 가동조건이 없습니다");
          return "설정된 센서 가동조건이 없습니다";
        }
        for (let i = 0; i < this.sensorcontrol.set.length; i++ ) {
          if (!this.sensorcontrol.set[i].sensor || !this.sensorcontrol.set[i].sensor.mac){
            this.$refs.sensor[i].focus();
            return "센서노드를 선택하세요.";
          }
          if (!this.sensorcontrol.set[i].data_name || !this.sensorcontrol.set[i].data_name.code ){
            this.$refs.data_name[i].focus();
            return "센서종류를 선택하세요.";
          }
          if (this.sensorcontrol.set[i].run < this.sensorcontrol.set[i].stop ){
            this.$refs.data_stop[i].focus();
            return "작동 조건보다 중지 조건을 적게 입력하세요.";
          }

          if (this.sensorcontrol.set[i].run <= 0){
            this.$refs.data_run[i].focus();
            return "가동조건을 확인하세요.";
          }
          if (this.sensorcontrol.set[i].stop <= 0 ){
            this.$refs.data_stop[i].focus();
            return "중지 기준지표를 확인하세요.";
          }
        }
      }

      if (this.weathercontrol.on) {
        if (!this.weathercontrol.set.length) { 
          alert("설정된 기상 가동조건이 없습니다");
          return "설정된 기상 가동조건이 없습니다";
        }
        for (let i = 0 ; i < this.weathercontrol.set.length; i++ ) {
          if (!this.weathercontrol.set[i].division || !this.weathercontrol.set[i].division.code ){
            this.$refs.weather_division[i].focus();
            return "기상종류를 선택하세요.";
          }

          if (this.weathercontrol.set[i].division.code == "pressure") { 
            if (this.weathercontrol.set[i].max > 1030 ) {
              this.$refs.pressure_max[i].focus();
              return "기압기준을 확인하세요.";
            }
            if (this.weathercontrol.set[i].max < 900 ) {
              this.$refs.pressure_max[i].focus();
              return "기압기준을 확인하세요.";
            }
          }
          
          if (this.weathercontrol.set[i].division.code == "deg") { 
            if (!this.weathercontrol.set[i].deg.name) {
              this.$refs.wind_deg[i].focus();
              return "풍향을 선택 입력하세요.";
            }
          }
          
          if (this.weathercontrol.set[i].run < 1 ){
            this.$refs.weather_run[i].focus();
            return "가동시간을 확인하세요.";
          }
          // if (this.weathercontrol.set[i].stop < 1 ){
          //   this.$refs.weather_stop[i].focus();
          //   return "중지 기준지표를 확인하세요.";
          // }
        }
      }
      return "";
    },  
    async infoDeodorizerSetting(id){
      this.loading = true;
      this.$store.commit("resMessage","");

      await Apis.infoDeodorizerSetting(
        {
          id: id,
        },(res) => {  
            if (res.result) {
              // console.log(res.data);
              this.id = res.data.id;
              this.device_name = res.data.device_name;
              this.farm = res.data.farm;
              this.room = res.data.room;
              this.plc_name = res.data.plc_name;
              this.btn_no = res.data.btn_no;
              this.nowweather = res.data.nowweather;
              this.chgdate = res.data.chgdate;
              this.refer_sensor = res.data.sensorvalues;
              this.timecontrol = res.data.timecontrol;
              this.sensorcontrol = res.data.sensorcontrol;
              this.weathercontrol = res.data.weathercontrol;
              this.rainstop = res.data.rainstop;
              this.snowstop = res.data.snowstop;
              this.tempstop = res.data.tempstop;
              this.templessthan = res.data.templessthan;
              this.direction = Common.getDirection(res.data.nowweather.wind.deg);
              this.comboSensors();
              this.sensordirection = Common.getDirection(res.data.nowweather.sensor.wind.deg);
              for (let i = 0; i < res.data.sensorcontrol.set.length; i++ ) {
                this.datanameItems.push(
                  [ {code: "nh3", name: '암모니아'},{code: "h2s", name: "황화수소"},{code: "co2", name: '이산화탄소'},{code: "temp", name: '온도'},{code: "hum", name: '습도'},
                    {code: "bp", name: '기압'},{code: "wd", name: '풍향'},{code: "ws", name: '풍속'}]
                );
              }
              this.loading = false;
              this.$store.commit("resMessage",res.message);
          } else {  
              alert(res.message);
              this.$store.commit("resMessage",res.message);
              this.loading = false;
            }
          }
        ).catch( (err) => {  // API 오류 처리
            console.log("infoDeodorizerSetting API 호출 오류",err)
            this.$store.commit("resMessage",err);
            // alert(err);
            this.loading = false;
        }
      )
      this.changed = false;

    },
    async comboSensors() {
      await Apis.comboSensors({
        company_cd: this.company &&  this.company.code || "",
        farm_cd: this.farm && this.farm.code || "",
        building_cd: this.building && this.building.code || "",
        room_cd: this.room && this.room.code || "",
        stand_date: dateUtil.format(new Date(), "yyyy-MM-dd"), 
        },(res) => {  
          if (res.result) {
            this.sensorItems = [];
            // console.log(res.data);
            for (let i in res.data ) {
            this.sensorItems.push({
              mac: res.data[i].sensor_mac,
              name: res.data[i].device_name,
              });
            }  
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboSensors API 호출 오류",err)
            alert(err);
        }
      ) 
    },
    changeSensor(s) {
        // 센서노드가 바뀌면 데이타네임 지우기
        this.sensorcontrol.set[s].data_name = {};
        // this.comboSensorData(s);
    },

    comboSensorData(s) {
      // console.log("s",s,this.sensorcontrol.set[s].sensor.mac)
      if (!this.sensorcontrol.set[s].sensor.mac) {
        this.$refs.sensor[s].focus();
        alert("센서노드를 먼저 선택하세요");
        this.$store.commit("resMessage","센서노드를 먼저 선택하세요");
        return;
      }

      Apis.comboSensorData({
        mac: this.sensorcontrol.set[s].sensor.mac,
        filter: true    // true: 암몸니아 황화수소 , false: 전체 센서종류
        },(res) => {  
          if (res.result) {
            this.datanameItems.splice(s,1,res.data);
          } else {
            alert(res.message);
          }
        }).catch( (err) => {  // API 오류 처리
            console.log("comboSensorData API 호출 오류",err)
            alert(err);
        }
      ) 
    },
    save(){
      let msgCheckdata = this.checkData(); 
      if (msgCheckdata){
        this.$store.commit("resMessage",msgCheckdata);
        return;
      }
      this.loadingSave = true;
      Apis.saveDeodorizerSetting({
        "id" : this.id,
        "timecontrol" : this.timecontrol,
        "sensorcontrol" : this.sensorcontrol,
        "weathercontrol" : this.weathercontrol,
        "rainstop": this.rainstop,
        "snowstop": this.snowstop,
        "tempstop" : this.tempstop,
        "templessthan" : this.templessthan,
        },(res) => {
          if (res.result) {
            this.$store.commit("resMessage",res.message);
            this.loadingSave = false;
            // this.$emit("refresh");
            this.infoDeodorizerSetting(this.id);
            this.$router.go(-1);
          } else {
            this.loadingSave = false;
            console.log("저장 오류",res.message)
          }
        }).catch( (err) => {  // API 오류 처리
            this.loadingSave = false;
            console.log("saveDeodorizerSetting API 호출 오류",err)
            alert(err);
        }
      )
    },
    removetime(t){    
      if (!confirm("시간 기준 제어 조건을 제거 하시겠습니까?")) return;
      this.timecontrol.set.splice(t, 1);
    },
    addtime(){
      this.timecontrol.set.push({"start": "00:00", "finish": "00:00", "run": 0, "stop": 0 });
    },

    removesensor(s){
      if (!confirm("센서 기준 제어 조건을 제거 하시겠습니까?"))  return;
      this.sensorcontrol.set.splice(s, 1);
      this.datanameItems.splice(s, 1);
    },

    addsensor(){
      this.sensorcontrol.set.push({ "data_name": {}, "run": 0, "sensor": {}, "stop": 0});
    },

    removeweather(w){
      if (!confirm("기상 기준 제어 조건을 제거 하시겠습니까?"))  return;
      this.weathercontrol.set.splice(w, 1);
    },
    addweather(){
      this.weathercontrol.set.push({"division": {}, "max": 0, "min": 0, "run": 0, "stop": 0, "deg": {"min": null, "max": null, "name": null } });
    },
    exit(){
      this.$router.go(-1);
    },

  }
}
</script>

<style scoped lang="scss">
@import '../../style/base.scss';
.site_content{
  margin-top:30px !important;
}
.info-setting{
  width:30%;  
}
.set-container{
  width:70%;
  max-width:730px;
  margin-left:30px;
  // margin-top:10px;
}

.info-card{
  background-color: white;
  border-radius: 10px;
  padding:15px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.plc_title{
  width:50px;
  color:#9f9f9f;
}
.plc_btn{
  background-color: #F5F5F5;
  border-radius: 7px;
  margin-left:5px;
  padding:0 10px;
}
.weather-info{
  background-color: #F0F2F5;
  border-radius: 5px;
  margin-top:10px;
  padding:10px;
}
.weather-title{
  width:80px;
  font-size:17px;
  font-weight:600;
}
.detail_info{
  display: flex;
  font-size:15px;
}
.sensor_title{
  width:155px;
  margin-left:15px;
  font-weight:600;
  letter-spacing: -1px;
}
.set_date{
  display:flex;
  justify-content:end;
  font-size:13px;
  color:#b1b1b1;
  letter-spacing: -1px;
}
.sensor_low{
  font-size:12px;
}
.btn-container{
  margin-top:20px;
}
.exit_btn , .save_btn{
  height:45px !important;
  width:100px;
  font-size:17px;
  border:1px solid $main-color;
  color:$main-color;
}
.save_btn{
  background-color: $main-color !important;
  color:white !important;
}
.set_title{
  width:140px;
  font-size:18px;
  font-weight:600;
  letter-spacing: -0.75px;
}
.deodorizer_set{
  margin-top:10px;
  background-color: white;
  padding:20px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}
.trash{
  background-color: #a3a3a3 !important;
  border-radius: 10px;
  cursor: pointer;
  margin-top:6px;
  width:30px !important;
  height:35px !important;
  line-height: 35px;
  text-align: center;
}
.reference{
  font-size:15px;
  color:#828282;
  margin-top:15px;
}
.control_btn{
  height:40px !important;
  font-size:15px !important;
  color: $main-color !important;
  border:1px solid $main-color !important;
}
.setting{
  margin-top:10px;
}
.set_time{
  // border:1px solid #828282 !important;
  height:42px !important; 
  margin-right:10px !important;
  width:180px !important;
}
::v-deep .v-text-field__slot .v-label {
  background-color:white;
}
::v-deep .v-input__control .v-input__slot{
  height: 42px !important;
  border:1px solid #828282 !important;
}
.run_time{
  width:125px;
  height:42px !important; 
  margin-right:5px !important;
}
.sensor_select{
  width:167px;
  // border:1px solid #828282;
  margin-right:10px !important;
  height:42px !important;
}
::v-deep .sensor_select .v-label{
  background-color: white !important;
}
::v-deep .v-select .v-input__control .v-input__slot{
  border-radius: 5px !important;
  border:1px solid #828282 !important;
  // background-color: red !important;
}
::v-deep .data_time{
  width:140px;
  height:42px !important;
  margin-right:5px !important;
}
::v-deep .data_time .v-input__control .v-input__slot{
  border:1px solid #828282 !important;
}
.windset_time{
  width:135px;
  height:42px;
  margin-right:10px !important;
}
.weatherpres_set{
  height:42px;
}
::v-deep .windset_time .v-label{
  background-color: white !important;
}
.weatherpres_set{
  width:230px !important;
  margin-right:10px !important;
}
::v-deep .weatherpres_set .v-label{
  background-color: white !important;
}
input:checked + .slider {
  background-color: $point-color !important; /* 활성화 색상 (브랜드 컬러) */
}
.set{
  align-items: center;
  border:1px solid #e5e5e5;
  border-radius: 10px;

}
.climate_title{
  font-size:17px;
  font-weight:600;
  padding:20px !important;
}
.checkbox{
  height:45px;
  margin-top:-5px;
  // border: none;
}
.press{
  height:50px;
}
::v-deep .temp_stop{
  width:140px;
  height:42px;
}
::v-deep .checkbox .v-input__control .v-input__slot {
  border: none !important;
}
::v-deep .v-select__selections{
  margin-top:-5px !important;
}
@media only screen and (max-width: 768px) {
.mb-deodorizer{
  flex-direction: column;
}
.info-setting{
  width:100%;
}
.set-container{
  width:100%;
  margin-left:5px;
  margin-top:20px;
}
.set_time{
  width:150px !important;
}
.run_time{
  margin-top:5px !important;
}
.sensor_select{
  width:150px;
}
.trash{
  margin-top:10px;
}
.data_time{
  width:130px;
  margin-top:5px !important;
}
.windset_time{
  width:130px;
}
.weatherpres_set{
  width:160px !important;
}
.mb-check{
  flex-direction: column;
  justify-content: left !important;
}
}

</style>